export const NUMBER_INPUT_DIGITS = {
  ELEMENT_VALUES: 12,
  JIRA_DASHBOARD_DISPLAY_ELEMENTS: 3,
  BILLING_PHONE_NUMBER: 12
}

export const NUMBER_INPUT_FRACTIONS = {
  ELEMENT_VALUES: 2
}
